module.exports = __webpack_public_path__ + "static/sport/bgi-pc.4adedd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/bgi-pc.png
// module id = 5ok3
// module chunks = 0